var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('div',{staticClass:"backdrop",attrs:{"aria-hidden":"true"}},[_c('div',{staticClass:"backdrop-grid"}),_c('div',{staticClass:"backdrop-glow"})]),_c('Navbar'),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }